import React, { useState, useEffect } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { useSelector } from 'react-redux'

import PieTimerAnimation from 'components/common/animations/PieTimer'
import { EmojiIcon } from 'components/EmojiIcon'
import {
    gesturesMap,
    gestureTypes,
    gesturesData,
    gesturesKeys,
} from 'components/Tiles/Student/Gestures'
import {
    controlBarGestureEventEmitter,
    gestureKeys,
    emitGestureMsg,
} from 'helpers/events'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { _staticGestures } from 'store/selectors/Gestures'
import { isDesktop } from 'utils/device'
import { logger } from 'utils/logger'

import StyledSwitch from './StyledSwitch/StyledSwitch'
import { PieTimerWrapper } from './styles'

import { WrapperDiv, MenuButton, EmojiWrapper } from '../styles'
import StyledTooltip from '../TooltipWrapper'

const GestureControlButtons = props => {
    const [selectedKey, setSelectedKey] = useState('')
    const staticGestures = useSelector(_staticGestures)
    const [switchState, setSwitchState] = useState(false)
    const [isCheckboxDisabled, setCheckboxDisabled] = useState(false)

    const { userId } = useVideoContext()

    /* Contols should not render for remote participants and disable gestures on mobile*/

    const triggerGestureFromControlBar = React.useCallback(
        id => {
            const gesture = gesturesData.find(item => item.id === id)
            const isGestureAutoReversible = !(gesture.autoRevert === false)
            if (switchState || selectedKey || isCheckboxDisabled) return
            setSelectedKey(gesture.gestureKey)
            emitGestureMsg({
                gestureKey: gesture.gestureKey,
                autoHide: isGestureAutoReversible,
                ...(!isGestureAutoReversible
                    ? {
                          gestureType: gestureTypes.static,
                      }
                    : null),
            })
            setCheckboxDisabled(true)
            setTimeout(() => {
                setSelectedKey('')
                setCheckboxDisabled(false)
            }, 2000)
            logger.debug(`Gesture fired : ${gesture.gestureKey} `)
        },
        [switchState, selectedKey, isCheckboxDisabled]
    )

    const handleHotKeyTrigger = React.useCallback(
        gesture => triggerGestureFromControlBar(gesture),
        [triggerGestureFromControlBar]
    )

    useEffect(() => {
        controlBarGestureEventEmitter.addListener(
            gestureKeys.HOTKEY_GESTURE,
            handleHotKeyTrigger
        )
        return () =>
            controlBarGestureEventEmitter.removeListener(
                gestureKeys.HOTKEY_GESTURE,
                handleHotKeyTrigger
            )
    }, [handleHotKeyTrigger])

    useEffect(() => {
        let gesture = Object.values(staticGestures).find(
            el => el.from_user === userId
        )
        let swicthValue = false
        if (
            gesture &&
            gesture.gesture_type &&
            gesture.gesture_type === gestureTypes.static &&
            gesture.gesture === gesturesMap.raiseHand
        ) {
            swicthValue = true
        }
        setSwitchState(swicthValue)
    }, [staticGestures, userId])

    return (
        <>
            <StyledSwitch disabled={isCheckboxDisabled} />

            {gesturesData.map(gesture => {
                const {
                    id,
                    gestureKey,
                    available,
                    assetPath,
                    mobileAssetPath,
                } = gesture
                let tooltipNames = gestureKey //to convert tooltip names to be small cased seperated strings
                    .match(/([A-Z]?[^A-Z]*)/g)
                    .slice(0, -1)
                    .join(' ')

                return gestureKey !== gesturesKeys.raiseHand ? (
                    <WrapperDiv
                        key={`mb-ges-${gestureKey}`}
                        isMobile={isMobileOnly}
                    >
                        <StyledTooltip
                            title={isDesktop ? tooltipNames.toLowerCase() : ''}
                            onClick={() => triggerGestureFromControlBar(id)}
                            placement="left"
                            arrow
                            PopperProps={{ disablePortal: true }}
                        >
                            <MenuButton
                                className="MenuButton"
                                disabled={selectedKey || switchState}
                            >
                                {gestureKey === selectedKey && (
                                    <PieTimerWrapper>
                                        <PieTimerAnimation />
                                    </PieTimerWrapper>
                                )}

                                <EmojiWrapper>
                                    <EmojiIcon
                                        key={gestureKey}
                                        emoji={{ id }}
                                    />
                                </EmojiWrapper>
                            </MenuButton>
                        </StyledTooltip>
                    </WrapperDiv>
                ) : null
            })}
        </>
    )
}

export default GestureControlButtons
